import { ProductTier } from '@sparemin/api-sdk';
import * as React from 'react';

import { useSelector } from 'react-redux';
import { SubscriptionPeriod } from 'blocks/Pricing/types';
import Button from 'components/Button';
import PlanAction from '../PlanAction';
import { planCTALabelSelector } from '../selectors';
import { block } from './utils';

export interface ProGrowPlanCtaProps {
  period: SubscriptionPeriod;
  onClick?: () => void;
}

const ProGrowPlanCta: React.FC<ProGrowPlanCtaProps> = ({ period, onClick }) => {
  const label = useSelector(state =>
    planCTALabelSelector(state, {
      tier: ProductTier.PRO,
      subscriptionPeriod: period,
    }),
  );

  return (
    <PlanAction className={block('cta')} onClick={onClick}>
      <Button theme="rainbow">
        <span className={block('cta-text')}>{label}</span>
      </Button>
    </PlanAction>
  );
};

export default ProGrowPlanCta;
